"use client";

import SearchBar from "./SearchBar";
import { useEffect, useState } from "react";
import FeatureBanner from "./FeatureBanner";
import { SearchPageModel } from "@/types/SearchPageModel";
import { SearchModel } from "@/types/SearchModel";
import { LocalityModel } from "@/types/LocalityModel";
import { ListWithPages } from "./ListWithPages";
import SearchResult from "./SearchResult";

export default function SearchPage({ data }: { data: SearchPageModel }) {
  const [search, setSearch] = useState<SearchModel>({
    ville: "",
    codePostal: "",
  });
  const numberOfElements = 60;
  const [currentPage, setCurrentPage] = useState(1);
  const numberOfPages = Math.ceil(data.localites.length / numberOfElements);

  let startIndex = numberOfElements * (currentPage - 1);
  let localites = data.localites.slice(0);

  const [slicedLocalites, setSlicedLocalites] = useState(
    localites
      .splice(startIndex, numberOfElements)
      .sort((a, b) => (a.name < b.name ? -1 : 1)),
  );
  const [searchList, setSearchList] = useState<LocalityModel[]>([]);

  useEffect(() => {
    if (search.codePostal == "" && search.ville == "") {
      localites = data.localites
        .slice(0)
        .sort((a, b) => (a.name < b.name ? -1 : 1));
      startIndex = numberOfElements * (currentPage - 1);
      setSlicedLocalites(localites.splice(startIndex, numberOfElements));
      setSearchList([]);
    }
  }, [search.codePostal, search.ville]);

  const filterList = () => {
    localites = data.localites.slice(0);
    if (search.codePostal && search.ville) {
      setSearchList(
        localites
          .filter(
            (page) =>
              page.postalCodes.includes(search.codePostal) &&
              page.displayName
                .toLowerCase()
                .startsWith(search.ville.toLowerCase()),
          )
          .sort((a, b) => (a.name < b.name ? -1 : 1)),
      );
    } else {
      setSearchList(
        localites
          .filter(
            (page) =>
              page.postalCodes.includes(search.codePostal) ||
              page.displayName
                .toLowerCase()
                .startsWith(
                  search.ville == "" ? " " : search.ville.toLowerCase(),
                ),
          )
          .sort((a, b) => (a.name < b.name ? -1 : 1)),
      );
    }
  };

  const handleClick = (page: number) => {
    localites = data.localites
      .slice(0)
      .sort((a, b) => (a.name < b.name ? -1 : 1));
    setCurrentPage(page);
    startIndex = numberOfElements * (page - 1);
    setSlicedLocalites(localites.splice(startIndex, numberOfElements));
  };

  return (
    <>
      <div className="mx-auto flex h-full max-w-7xl flex-1 flex-col xsmall:py-20 lg:py-16">
        <FeatureBanner
          props={data.banner}
          className="lg:px:8 mx-auto px-6 text-center"
        />
        <SearchBar
          search={search}
          setSearch={setSearch}
          filterList={filterList}
        />
        {searchList.length == 0 ? (
          <ListWithPages
            currentPage={currentPage}
            handleClick={handleClick}
            localites={slicedLocalites}
            numberOfPages={numberOfPages}
          />
        ) : (
          <SearchResult localites={searchList} />
        )}
      </div>
    </>
  );
}
